import React, { useState } from "react";
import { EnvironmentOutlined } from "@ant-design/icons";
import "./index.scss";

// Hidden details are blurred, as the candidate and employer apps do, and read
// to screen readers as what they stand for.
export const Hidden = ({ children, label }) => (
  <span className="stealth-preview-hidden">
    <span aria-hidden="true">{children}</span>
    <span className="stealth-preview-sr">{label}</span>
  </span>
);

// A profile or job card that flips between its Stealth and Non-Stealth
// versions with the apps' "Stealth Mode" switch. Starts in Stealth, the
// apps' default. Both versions share one grid cell, so the card keeps the
// height of the taller one and nothing below it moves when it's flipped.
const StealthPreview = ({
  theme = "light",
  heading,
  stealth,
  visible,
  avatarShape = "round",
  className = "",
}) => {
  const [isStealth, setIsStealth] = useState(true);
  const [hasToggled, setHasToggled] = useState(false);

  const toggle = () => {
    setIsStealth((current) => !current);
    setHasToggled(true);
  };

  const views = [
    { key: "stealth", view: stealth, active: isStealth },
    { key: "visible", view: visible, active: !isStealth },
  ];

  return (
    <div
      className={`stealth-preview stealth-preview--${theme} stealth-preview--${avatarShape}-avatar ${className}`}
    >
      <div className="stealth-preview-controls">
        <button
          type="button"
          role="switch"
          aria-checked={isStealth}
          className={`stealth-switch${hasToggled ? "" : " stealth-switch--hint"}`}
          onClick={toggle}
        >
          <span className="stealth-switch-track" aria-hidden="true">
            <span className="stealth-switch-thumb" />
          </span>
          <span className="stealth-switch-label">Stealth Mode</span>
          <span className="stealth-switch-state" aria-hidden="true">
            {isStealth ? "ON" : "OFF"}
          </span>
        </button>
        {!hasToggled && (
          <span className="stealth-preview-try" aria-hidden="true">
            Try it
          </span>
        )}
      </div>

      <div className="stealth-preview-card">
        {heading && <div className="stealth-preview-heading">{heading}</div>}
        <div className="stealth-preview-views">
          {views.map(({ key, view, active }) => (
            <div
              key={key}
              className={`stealth-preview-view${active ? " is-active" : ""}`}
              aria-hidden={!active}
            >
              <div className="stealth-preview-identity">
                <span
                  className={`stealth-preview-avatar stealth-preview-avatar--${key}`}
                >
                  {view.avatar}
                </span>
                <div className="stealth-preview-text">
                  <div className="stealth-preview-title">{view.title}</div>
                  <div className="stealth-preview-subtitle">{view.subtitle}</div>
                  <div className="stealth-preview-location">
                    <EnvironmentOutlined /> {view.location}
                  </div>
                </div>
              </div>
              <div className="stealth-preview-note">
                {view.noteIcon} {view.note}
              </div>
            </div>
          ))}
        </div>
      </div>

      <span className="stealth-preview-sr" aria-live="polite">
        {hasToggled
          ? `Stealth Mode ${isStealth ? "on" : "off"}. ${
              isStealth ? stealth.note : visible.note
            }.`
          : ""}
      </span>
    </div>
  );
};

export default StealthPreview;
